"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryResponseResultsInnerDataValueValueInner = instanceOfApiPostQueryResponseResultsInnerDataValueValueInner;
exports.ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSON = ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSON;
exports.ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSONTyped = ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSONTyped;
exports.ApiPostQueryResponseResultsInnerDataValueValueInnerToJSON = ApiPostQueryResponseResultsInnerDataValueValueInnerToJSON;
exports.ApiPostQueryResponseResultsInnerDataValueValueInnerToJSONTyped = ApiPostQueryResponseResultsInnerDataValueValueInnerToJSONTyped;
/**
 * Check if a given object implements the ApiPostQueryResponseResultsInnerDataValueValueInner interface.
 */
function instanceOfApiPostQueryResponseResultsInnerDataValueValueInner(value) {
    return true;
}
function ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSON(json) {
    return ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSONTyped(json, false);
}
function ApiPostQueryResponseResultsInnerDataValueValueInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'value': json['value'] == null ? undefined : json['value'],
    };
}
function ApiPostQueryResponseResultsInnerDataValueValueInnerToJSON(json) {
    return ApiPostQueryResponseResultsInnerDataValueValueInnerToJSONTyped(json, false);
}
function ApiPostQueryResponseResultsInnerDataValueValueInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'value': value['value'],
    };
}
